import {
  apiRequest,
  riwayatPendidikanCreate,
  masterEducation,
  masterRumpun,
  ListJabatan,
  masterEmployee,
} from "../../../../../services/adapters/kepegawaian/riwayatPendidikanService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      riwayatPendidikanCreate,
      {
        body: query,
      },
      true
    );
  };

  fetchEducation = async (query) => {
    return await apiRequest(
      "get",
      masterEducation,
      {
        params: query,
      },
      true
    );
  };
  fetchRumpun = async (query) => {
    return await apiRequest(
      "get",
      masterRumpun,
      {
        params: query,
      },
      true
    );
  };

  fetchListJabatan = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      ListJabatan,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchEmployee = async (query) => {
    return await apiRequest(
      "get",
      masterEmployee,
      {
        params: query,
      },
      true
    );
  };
}

export default CreateRepository;
